import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { ProyectosService } from "./../proyectos.service";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ModalAgregarProyectoComponent } from "../modal-agregar-proyecto/modal-agregar-proyecto.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { abrirDialogoNuevaVersion } from "../modal-agregar-version/modal-agregar-version.component";
import { SIN_DATO, mensajeVersionCreada } from "../proyecto-pagina/etapas-versiones.util";
import { TipoFiltroProyecto } from "src/app/utilerias/enums/tipo-filtro-proyecto.enum";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import { AuthService } from "src/app/security/auth.service";
import { GestionclientesService } from "src/app/clientes/gestionclientes.service";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { comentariosAvances } from "src/app/shared/model/gestion-proyectos/comentariosAvances";
import { ModalComentariosDeAvancesComponent } from "./modal-comentarios-de-avances/modal-comentarios-de-avances.component";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { CommonModule } from "@angular/common";
import { MatInputModule } from "@angular/material/input";
import { MatOptionModule } from "@angular/material/core";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ConsultaRiesgosComponent } from "../gestion_riesgos/consulta-riesgos/consulta-riesgos.component";
import { Router, RouterLink } from "@angular/router";
import { Subscription, finalize, forkJoin } from "rxjs";
import {
  Grafica,
  configGraficaAvance,
  configGraficaEsfuerzo,
  configGraficaRiesgo,
  datosGraficaAvance,
  datosGraficaEsfuerzo,
  datosGraficaRiesgo,
  decorarProyectoParaVista,
  pintarGraficaBarra,
} from "../utilerias/proyecto-indicadores.util";
import { abrirSeguimientoDeProyecto } from "../utilerias/seguimiento-proyecto";
import { CODIGOS_VERSIONES, ResumenEtapasRespuesta, ResumenProyectoEtapas } from "../proyecto-pagina/etapas-versiones.model";
import { EtapasVersionesService } from "../proyecto-pagina/etapas-versiones.service";
import {
  llaveCopiaProyecto,
  rutaAltaRiesgo,
  rutaEditorEtapa,
  rutaEditorProyecto,
  rutaPaginaProyecto,
} from "../proyecto-pagina/proyecto-pagina.rutas";
import { FilaEtapaTarjeta, filasEtapasTarjeta, lotesDeIds } from "./etapas-tarjeta.util";

/** Las etapas de un proyecto antes de pintar su tabla (o si no tiene). */
const SIN_FILAS: readonly FilaEtapaTarjeta[] = [];

@Component({
  selector: "app-gestion-proyectos",
  templateUrl: "./gestion-proyectos.component.html",
  styleUrls: ["./gestion-proyectos.component.css"],
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    MatDividerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatTooltipModule,
    RouterLink,
    ConsultaRiesgosComponent,
  ],
})
export class GestionProyectosComponent implements OnInit, OnDestroy {
  dialogRef: MatDialogRef<any>;
  projects: Array<Proyecto> = [];
  projectsOriginal: Array<Proyecto> = [];
  tipoFiltros: string[];
  /** PROYECTOS_ETAPAS_RESUMEN de los proyectos de la página: etapas (A0b) y defectos con tenant. */
  resumenes: Partial<Record<string, ResumenProyectoEtapas>> = {};
  /** La tabla de etapas de cada tarjeta (A0b), por id de proyecto. */
  etapasPorProyecto: Partial<Record<string, readonly FilaEtapaTarjeta[]>> = {};
  readonly sinDato = SIN_DATO;
  proyectosSinComentariosRecientes: Proyecto[] = []; // 🟢 NUEVO: lista de proyectos sin comentarios recientes

  [x: string]: any;
  inicio = 0;
  regPag = 3;
  regPagCliente = 1000;
  requestFilter = new ConsultaList<Proyecto>();
  requestCliente = new ConsultaList<Cliente>();
  nomProyecto: string = "";
  clientefl: string = "";
  estatusFl: string = "";
  modoFiltroEstatus = false;
  regPagOriginal = this.regPag;
  filtroProyectoUsuario: "MIS" | "TODOS" = "MIS";
  liderSeleccionadoId: number | null = null;
  listaLideres: any[] = []; // viene del servicio
  formCliente = new FormControl();
  listaClientes: Array<Cliente> = [];

  proyecto: Proyecto;
  comentariosAvances: Array<comentariosAvances> = [];
  comentarioReciente: string;
  comentariosRecientes: {
    idProyecto: string;
    descripcion: string;
    nombreUsuario: string;
    fecha: string;
  }[] = [];
  mostrarPrincipal: boolean;
  mostrarConsulta: boolean;
  mostrarMascara: boolean;
  permisoProyecto: boolean = false;
  colorFaltanteGrafica: string = "rgba(176, 176, 176)";
  loading = false;
  readonly pageSizeOptions = [3, 5, 10];

  private lecturaResumen?: Subscription;

  constructor(
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly proyectoService: ProyectosService,
    private readonly clientService: GestionclientesService,
    private readonly utileriasService: UtileriasService,
    private readonly authS: AuthService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly etapasVersionesService: EtapasVersionesService
  ) { }

  ngOnInit() {
    // 🔐 Usuario logeado
    const usuario: any =
      (this.authS as any).usuario || (this.authS as any).currentUser;

    // 📄 Configuración de paginación
    this.config = {
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };

    // 🟢 Filtro por defecto: MIS PROYECTOS
    this.filtroProyectoUsuario = "MIS";
    if (usuario?.id) {
      this.requestFilter.param6 = usuario.id;
    } else {
      delete this.requestFilter.param6;
    }

    // 🔍 Primera consulta
    this.inicio = 0;
    this.consultarProyectos();

    // ⚙️ Carga inicial
    this.obtenerSeveridad();
    this.mostrarPrincipal = true;
    this.tipoFiltros = TipoFiltroProyecto.values();

    // 👥 Clientes
    this.requestCliente.regInicial = 0;
    this.requestCliente.regXPagina = this.regPagCliente;
    this.consultarClientes();

    this.formCliente.valueChanges.subscribe(() => {
      this.filtraCliente();
    });
  }

  ngOnDestroy(): void {
    this.lecturaResumen?.unsubscribe();
  }

  get totalPages(): number {
    return this.config?.totalItems > 0 && this.config?.itemsPerPage > 0
      ? Math.ceil(this.config.totalItems / this.config.itemsPerPage)
      : 0;
  }

  get showPagination(): boolean {
    return (this.config?.totalItems ?? 0) > 0;
  }

  get paginatedProjects(): Array<Proyecto> {
    if (!Array.isArray(this.projects)) {
      return [];
    }

    if (!this.modoFiltroEstatus) {
      return this.projects;
    }

    const start = (this.config.currentPage - 1) * this.config.itemsPerPage;
    return this.projects.slice(start, start + this.config.itemsPerPage);
  }

  get rangeEnd(): number {
    return Math.min(
      this.config.currentPage * this.config.itemsPerPage,
      this.config.totalItems
    );
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.config.currentPage - 1,
      this.config.currentPage,
      this.config.currentPage + 1,
    ]);
    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === "number";
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.config.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.config.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPageSizeChange(value: number): void {
    this.config.itemsPerPage = Number(value);
    this.regPagOriginal = this.config.itemsPerPage;
    this.regPag = this.modoFiltroEstatus ? 10000 : this.config.itemsPerPage;
    this.inicio = 0;
    this.config.currentPage = 1;
    this.consultarProyectos();
  }

  onProjectNameChange(): void {
    this.inicio = 0;
    this.config.currentPage = 1;
    this.consultarProyectos();
  }

  onClienteChange(): void {
    this.inicio = 0;
    this.config.currentPage = 1;
    this.consultarProyectos();
  }

  onChangeEstatus() {
    this.inicio = 0;
    this.config.currentPage = 1;

    this.modoFiltroEstatus = !!this.estatusFl;

    // ⚠️ solo para traer todo del backend
    this.regPag = this.modoFiltroEstatus ? 10000 : this.regPagOriginal;

    this.consultarProyectos();
  }
  aplicarFiltroProyectoUsuario(): void {
    this.inicio = 0;
    this.config.currentPage = 1;
    this.consultarProyectos();
  }

  consultarProyectos(): void {
    this.loading = true;
    this.cdr.detectChanges();
    this.requestFilter.param1 = this.nomProyecto || "";
    this.requestFilter.param2 = this.clientefl || "";
    const usuario: any =
      (this.authS as any).usuario || (this.authS as any).currentUser;

    // 🔹 Backend por FLAGS (NO por ID)
    if (this.filtroProyectoUsuario === "MIS") {
      this.requestFilter.param6 = 1; // 👈 MIS PROYECTOS
    } else {
      this.requestFilter.param6 = 0; // 👈 TODOS
    }
    this.requestFilter.regInicial = this.inicio;
    this.requestFilter.regXPagina = this.regPag;
    this.requestFilter.pagina = this.config.currentPage - 1;

    this.proyectoService.consultaProyectoMongo(this.requestFilter).pipe(
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    ).subscribe(
      (response) => {
        if (response) {
          const responseProjects = Array.isArray(response.content)
            ? response.content
            : Array.isArray(response.list)
              ? response.list
              : [];

          // 🔹 Guardar respuesta original
          this.projectsOriginal = responseProjects.map((project) =>
            this.decorateProjectForView(project)
          );

          // 🔹 Aplicar filtro por estatus SI está activo
          if (this.modoFiltroEstatus && this.estatusFl) {
            this.projects = this.projectsOriginal.filter(
              (p) => p.estatus?.toUpperCase() === this.estatusFl
            );

            // 👈 total correcto solo para UI
            this.config.totalItems = this.projects.length;
          } else {
            this.projects = [...this.projectsOriginal];
            this.config.totalItems = Number(
              response.totalElements ?? response.pTotalItems ?? responseProjects.length
            );
          }
          if (this.totalPages > 0 && this.config.currentPage > this.totalPages) {
            this.config.currentPage = this.totalPages;
          }

          this.comentariosRecientes = this.projects.map((proy: any) => ({
            idProyecto: proy.idProyecto,
            descripcion:
              proy.latestComment?.descripcion || "No hay comentarios disponibles.",
            nombreUsuario: proy.latestComment?.nombreUsuario || "",
            fecha: proy.latestComment?.fecha || "",
          }));

          // 🟢 Detectar proyectos sin comentarios recientes
          this.verificarProyectosSinComentariosRecientes();

          // Etapas de las tarjetas (A0b) y defectos; luego las gráficas
          this.leerResumenEtapas();
          this.cdr.detectChanges();
          this.renderVisibleProjectCharts();
        }
      },
      (error) => {
        console.error("Error al obtener proyectos:", error);
        this.projects = [];
        this.config.totalItems = 0;
        this.leerResumenEtapas();
        this.cdr.detectChanges();
      }
    );
  }

  /** Lo que la tarjeta pinta del proyecto (proyecto-indicadores.util, lo mismo que la página del proyecto). */
  private decorateProjectForView(project: Proyecto): Proyecto {
    return decorarProyectoParaVista(project);
  }

  verificarProyectosSinComentariosRecientes(): void {
    const hoy = new Date();

    // 🔹 Solo ejecuta la verificación si es viernes a las 12:00 p.m.
    const esViernes = hoy.getDay() === 5; // 0=Domingo ... 5=Viernes
    const esMediodia = hoy.getHours() === 12 && hoy.getMinutes() === 0;

    if (!esViernes || !esMediodia) {
      console.log(
        "⏰ No es el momento programado (solo viernes a las 12:00 p.m.)"
      );
      return;
    }

    const diasLimite = 7; // cantidad de días sin comentar

    this.proyectosSinComentariosRecientes = this.projects.filter((proy) => {
      const comentarios = proy.comentariosAvances || [];
      if (comentarios.length === 0) return true;

      const comentarioMasReciente = comentarios
        .slice()
        .sort((a, b) => b.id - a.id)[0];

      const fechaComentario = new Date(comentarioMasReciente.fecha);
      const diferenciaDias =
        (hoy.getTime() - fechaComentario.getTime()) / (1000 * 60 * 60 * 24);

      return diferenciaDias > diasLimite;
    });

    console.log(
      "🚨 Proyectos sin comentarios recientes:",
      this.proyectosSinComentariosRecientes
    );

    if (this.proyectosSinComentariosRecientes.length > 0) {
      this.snackBar.open(
        `⚠️ ${this.proyectosSinComentariosRecientes.length} proyecto(s) no tienen comentarios recientes.`,
        "Ver",
        {
          duration: 15000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["snackbar-warning"],
        }
      );
    }
  }
  /**
   * A0b: las etapas y los defectos de las tarjetas visibles, en una llamada
   * a PROYECTOS_ETAPAS_RESUMEN (en lotes de 50 si hubiera más). Mientras
   * llega, o si falla, cada tabla sale con las etapas de la lista y «—» en
   * Estado, Última prueba, Abiertas y Defectos.
   */
  leerResumenEtapas(): void {
    this.lecturaResumen?.unsubscribe();
    this.resumenes = {};
    this.armarTablasEtapas();
    const lotes = lotesDeIds(this.paginatedProjects.map((proyecto) => proyecto?.id));
    if (lotes.length === 0) {
      return;
    }
    this.lecturaResumen = forkJoin(lotes.map((ids) => this.etapasVersionesService.resumenEtapas(ids))).subscribe({
      next: (respuestas) => {
        this.resumenes = resumenesDe(respuestas);
        this.armarTablasEtapas();
        this.cdr.detectChanges();
      },
      error: () => {
        this.resumenes = {};
      },
    });
  }

  /** La tabla de etapas de la tarjeta (A0b). */
  filasDe(proyecto: Proyecto): readonly FilaEtapaTarjeta[] {
    return this.etapasPorProyecto[proyecto.id] ?? SIN_FILAS;
  }

  /** «Defectos: N» con tenant, del resumen; «—» mientras llega o si no se pudo leer. */
  totalDefectos(proyecto: Proyecto): number | string {
    return this.resumenes[proyecto.id]?.totalDefectos ?? SIN_DATO;
  }

  /** La página del proyecto en el flujo de la lista (ODP, LIDER, AUDITORIA o la raíz). */
  rutaPagina(proyecto: Proyecto): string {
    return rutaPaginaProyecto(this.router.url, proyecto.id);
  }

  trackEtapa(_: number, fila: FilaEtapaTarjeta): string {
    return fila.clave;
  }

  private armarTablasEtapas(): void {
    const tablas: Partial<Record<string, readonly FilaEtapaTarjeta[]>> = {};
    for (const proyecto of this.paginatedProjects) {
      if (proyecto?.id) {
        tablas[proyecto.id] = filasEtapasTarjeta(proyecto.etapas, this.resumenes[proyecto.id]);
      }
    }
    this.etapasPorProyecto = tablas;
  }

  onPageChange(page: number): void {
    if (page === this.config.currentPage || page < 1 || page > this.totalPages) {
      return;
    }

    this.config.currentPage = page;

    if (this.modoFiltroEstatus) {
      this.leerResumenEtapas();
      this.cdr.detectChanges();
      this.renderVisibleProjectCharts();
      return;
    }

    this.inicio = (page - 1) * this.config.itemsPerPage;
    this.requestFilter.regInicial = this.inicio;
    this.requestFilter.regXPagina = this.config.itemsPerPage;
    this.consultarProyectos();
  }

  private obtenerSeveridad() {
    this.proyectoService
      .consultaGeneral(UrlConstantes.consultaSeveridad)
      .subscribe((res) => {
        if (res != null) {
          this.severidad = res.list;
        }
      });
  }

  consultarClientes(): void {
    this.clientService
      .filtroBusquedaCliente(this.requestCliente)
      .subscribe((res) => {
        if (res) {
          this.listaClientes = res.list;
        }
      });
  }

  filtraCliente() {
    if (!this.listaClientes) {
      this.clientService
        .filtroBusquedaCliente(this.requestCliente)
        .subscribe((res) => {
          this.listaClientes = res.list;
        });
    }
    let search = this.formCliente.value;
    if (!search && this.listaClientes) {
      return;
    } else {
      search = search.toLowerCase();
    }
    this.requestCliente.param1 = search;
    this.clientService
      .filtroBusquedaCliente(this.requestCliente)
      .subscribe((res) => {
        this.listaClientes = res.list;
      });
  }

  clearNombrePro() {
    this.nomProyecto = "";
    this.onProjectNameChange();
  }

  clearNombreCli() {
    this.formCliente.setValue("");
    this.clientefl = "";
    this.requestFilter.param2 = null;
    this.onClienteChange();
    this.consultarClientes();
  }

  private buildProjectSnapshot(proyecto: Proyecto): Proyecto {
    return JSON.parse(JSON.stringify(proyecto ?? {})) as Proyecto;
  }

  private persistProjectSnapshot(proyecto: Proyecto): void {
    const projectId = proyecto?.id;
    if (!projectId) {
      return;
    }

    sessionStorage.setItem(
      llaveCopiaProyecto(this.router.url, projectId),
      JSON.stringify(this.buildProjectSnapshot(proyecto)),
    );
  }

  irASeguimiento(proyecto: Proyecto): void {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }

    this.dialogRef = abrirSeguimientoDeProyecto(this.dialog, proyecto);
    this.dialogRef.afterClosed().subscribe((huboCambios) => {
      if (huboCambios) {
        this.consultarProyectos();
      }
    });
  }

  openDialogAddProject(): void {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    this.dialogRef = this.dialog.open(ModalAgregarProyectoComponent, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      data: null,
      panelClass: "custom-modalbox",
    });

    this.dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.consultarProyectos();
      }
    });
  }

  openDialogAditProject(proyecto: Proyecto): void {
    if (!proyecto?.id) {
      return;
    }

    const proyectoSnapshot = this.buildProjectSnapshot(proyecto);
    this.persistProjectSnapshot(proyectoSnapshot);

    this.router.navigateByUrl(rutaEditorProyecto(this.router.url, proyecto.id), {
      state: {
        proyecto: proyectoSnapshot,
      },
    });
  }

  /** «Crear etapa»: el alta de etapa de siempre, con la copia del proyecto (editar una etapa se hace desde la página). */
  openDialogAddStage(proyecto: Proyecto): void {
    if (!proyecto?.id) {
      return;
    }

    const proyectoSnapshot = this.buildProjectSnapshot(proyecto);
    this.persistProjectSnapshot(proyectoSnapshot);

    this.router.navigateByUrl(rutaEditorEtapa(this.router.url, proyecto.id, null), {
      state: {
        proyecto: proyectoSnapshot,
        etapa: null,
      },
    });
  }

  /**
   * «Crear versión» (T1) desde la tabla de etapas de la tarjeta (A0b): sale
   * en una etapa sin vigente, sin terminar y con permiso (§5.1), y como
   * «Nueva versión» si la etapa tiene resoluciones que esperan versión (T3b).
   * El diálogo crea la versión con su endpoint; aquí se avisa y se recarga la
   * lista, con su resumen.
   */
  crearVersion(proyecto: Proyecto, fila: FilaEtapaTarjeta): void {
    if (!proyecto?.id || !fila?.idEtapa || this.dialog.openDialogs.length > 0) {
      return;
    }
    abrirDialogoNuevaVersion(this.dialog, {
      idProyecto: proyecto.id,
      idEtapa: fila.idEtapa,
      nombreProyecto: proyecto.nombre,
      nombreEtapa: fila.nombre,
      estatusProyecto: proyecto.estatus,
    })
      .afterClosed()
      .subscribe((resultado) => {
        if (!resultado) {
          return;
        }
        const aviso = mensajeVersionCreada(resultado);
        if (aviso) {
          this.snackBar.open(aviso, "Cerrar", {
            duration: 6000,
            horizontalPosition: "right",
            verticalPosition: "top",
          });
        }
        this.consultarProyectos();
      });
  }

  cargaGraficasXProyecto() {
    this.paginatedProjects.forEach((proy) => {
      try {
        this.generarGraficaEsfuerzo(datosGraficaEsfuerzo(proy));
        this.generarGraficaAvance(datosGraficaAvance(proy));
        this.generarGraficaRiesgo(datosGraficaRiesgo(proy));
      } catch (e) {
        console.error(e);
      }
    });
  }

  generarGraficaEsfuerzo(datosGrafica: Grafica) {
    pintarGraficaBarra(`GraficaEsfuerzo-${datosGrafica.idProyecto}`, configGraficaEsfuerzo(datosGrafica));
  }
  generarGraficaAvance(datosGrafica: Grafica) {
    pintarGraficaBarra(`GraficaAvance-${datosGrafica.idProyecto}`, configGraficaAvance(datosGrafica));
  }
  generarGraficaRiesgo(datosGrafica: Grafica) {
    pintarGraficaBarra(`riesgo-${datosGrafica.idProyecto}`, configGraficaRiesgo(datosGrafica));
  }
  // 🔹 Calcular días totales entre inicio y fin (naturales)
  getDiasTotales(proy: Proyecto): number {
    const fechaInicio = new Date(proy.fechaInicio);
    const fechaFin = new Date(proy.fechaFin);
    return Math.ceil(
      (fechaFin.getTime() - fechaInicio.getTime()) / (1000 * 60 * 60 * 24)
    );
  }

  // 🔹 Calcular cuántos días corresponden al avance real
  getDiasAvanceReal(proy: Proyecto): number {
    const diasTotales = this.getDiasTotales(proy);
    return Math.round((proy.avanceReal / 100) * diasTotales);
  }

  // 🔹 Calcular cuántos días corresponden al avance planeado
  getDiasAvancePlaneado(proy: Proyecto): number {
    const diasTotales = this.getDiasTotales(proy);
    return Math.round((proy.avancePlaneado / 100) * diasTotales);
  }
  onChangeFiltroProyectoUsuario(): void {
    this.aplicarFiltroProyectoUsuario();
  }

  obtenerComentarioReciente(idProyecto: string): {
    descripcion: string;
    nombreUsuario: string;
    fecha: string;
  } {
    const comentarioReciente = this.comentariosRecientes.find(
      (comentario) => comentario.idProyecto === idProyecto
    );
    return (
      comentarioReciente ?? {
        descripcion: "No hay comentarios disponibles.",
        nombreUsuario: "",
        fecha: "",
      }
    );
  }

  verComentarios(proyecto: Proyecto): void {
    this.dialogRef = this.dialog.open(ModalComentariosDeAvancesComponent, {
      disableClose: true,
      autoFocus: true,
      width: "580px",
      minHeight: "300px",
      panelClass: "custom-modalbox",
      data: proyecto,
    });
  }

  obtenerEstatus(item: any): string {
    if (item.avanceReal === 100 && item.avancePlaneado === 100) {
      return "Finalizado";
    } else if (
      item.avanceReal >= item.avancePlaneado - 4 &&
      !(item.avanceReal >= item.avancePlaneado - 3)
    ) {
      return "En Proceso";
    } else if (
      item.avanceReal >= item.avancePlaneado ||
      item.avanceReal >= item.avancePlaneado - 3
    ) {
      return "En Tiempo";
    } else if (
      item.avanceReal <= item.avancePlaneado - 10 ||
      item.avancePlaneado > item.avanceReal
    ) {
      return "Retrasado";
    } else {
      return "";
    }
  }

  obtenerColor(item: any): string {
    if (item.avanceReal === 100 && item.avancePlaneado === 100) {
      return "#1390e9";
    } else if (
      item.avanceReal >= item.avancePlaneado - 4 &&
      !(
        item.avanceReal >= item.avancePlaneado ||
        item.avanceReal >= item.avancePlaneado - 3
      )
    ) {
      return "#e9e613";
    } else if (
      item.avanceReal >= item.avancePlaneado ||
      item.avanceReal >= item.avancePlaneado - 3
    ) {
      return "#299f45";
    } else if (
      item.avanceReal <= item.avancePlaneado - 10 ||
      item.avancePlaneado > item.avanceReal
    ) {
      return "#e91a13";
    } else {
      return "";
    }
  }

  openModRiesgo(proyecto: Proyecto) {
    this.router.navigate(rutaAltaRiesgo(this.router.url, proyecto.id), {
      state: {
        returnUrl: this.router.url,
        projectName: proyecto.nombre,
        projectClient: proyecto.nombreCliente,
        project: proyecto,
      },
    });
  }

  openConsultaRiesgo(proyecto: Proyecto): void {
    this.proyecto = proyecto;
    this.mostrarPrincipal = false;
    this.mostrarConsulta = true;
  }

  mostrarMascaraConsulta(mostrar: boolean) {
    if (mostrar) {
      this.mostrarMascara = true;
    } else {
      this.mostrarMascara = false;
    }
  }

  mostrarVistaPrincipal(vista: boolean) {
    if (vista) {
      this.mostrarPrincipal = true;
      this.mostrarConsulta = false;
      this.renderVisibleProjectCharts();
    }
  }

  getProjectStatusClass(item: Proyecto): string {
    const status = this.obtenerEstatus(item);
    if (status === "Finalizado" || status === "En Tiempo") {
      return "is-active";
    }
    if (status === "En Proceso") {
      return "is-pending";
    }
    return "is-danger";
  }

  getProjectDateRange(item: Proyecto): string {
    const inicio = item?.fechaInicio ? new Date(item.fechaInicio) : null;
    const fin = item?.fechaFin ? new Date(item.fechaFin) : null;

    if (!inicio || !fin) {
      return "Sin fechas";
    }

    return `${inicio.toLocaleDateString("es-MX")} - ${fin.toLocaleDateString("es-MX")}`;
  }

  private renderVisibleProjectCharts(): void {
    requestAnimationFrame(() => this.cargaGraficasXProyecto());
  }
}

/**
 * Los resúmenes de los lotes en un mapa por id de proyecto. Un lote
 * rechazado (pCodRetorno distinto de 00000) no aporta nada: sus tarjetas se
 * quedan con «—».
 */
function resumenesDe(respuestas: readonly ResumenEtapasRespuesta[]): Partial<Record<string, ResumenProyectoEtapas>> {
  const resumenes: Partial<Record<string, ResumenProyectoEtapas>> = {};
  for (const respuesta of respuestas) {
    if (respuesta?.pCodRetorno === CODIGOS_VERSIONES.EXITO) {
      Object.assign(resumenes, respuesta.proyectos);
    }
  }
  return resumenes;
}
